import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

const ActiveLink = ({ to, pathname, children, ...props }) => (
  <Link
    to={to}
    className={classnames({
      active: pathname.startsWith(to),
    })}
    {...props}
  >
    {children}
  </Link>
);

export default ActiveLink;



// WEBPACK FOOTER //
// src/modules/secured/components/layout/menu/ActiveLink.js